'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useEffect, useRef } from 'react';
import { noEmptySearchClient } from 'components/essentials/AlgoliaSearchClient';
import CatchAlgoliaSearchError from 'components/essentials/CatchAlgoliaSearchError';
import { InstantSearch, Configure, Index } from 'react-instantsearch';
import { ALGOLIA_HAS_LISTABLE_STOCK_FILTER, ALGOLIA_INDEX_NAME, DEFAULT_SEARCH_MODAL_NUMERIC_FILTERS } from 'commons/constants';
import useOpenSearch from 'global-state/isSearchOpen/useOpenSearch';
import useIsSearchOpen from 'global-state/isSearchOpen/useIsSearchOpen';
import useCloseSearch from 'global-state/isSearchOpen/useCloseSearch';
import useAdvancedSearchURL from 'components/consumer/consumer-search/advanced-search-next/hooks/useAdvancedSearchURL';
import useIsAdvancedSearch from 'components/consumer/consumer-search/hooks/useIsAdvancedSearch';
import JBSearchBoxNext from 'components/consumer/consumer-search/consumer-search-modal-next/components/JBSearchBoxNext';
import SearchResultsWrapperNext from 'components/consumer/consumer-search/consumer-search-modal-next/components/SearchResultsWrapperNext';
import CategoryHitsNext from 'components/consumer/consumer-search/consumer-search-modal-next/components/CategoryHitsNext';
import QuickLinkDialog from 'components/consumer/consumer-search/consumer-search-modal-next/components/QuickLinkDialog';
import ClearModalSearchQueryWhenClosed from 'components/consumer/consumer-search/consumer-search-modal-next/components/ClearModalSearchQueryWhenClosed';
import SearchModalProductListMobileNext from './components/SearchModalProductListMobileNext';
import StaticPageHitsNext from './components/StaticPageHitsNext';
import ResultsByCategoryNextMobile from './components/ResultsByCategoryNextMobile';

/**
 * Consumer Search Bar - Next version (for new Consumer app)
 * Uses React InstantSearch v7
 */

const InstantSearchMobileNext = t0 => {
  const $ = _c(20);
  const {
    toggleMobileSearchBar
  } = t0;
  const prevPathnameRef = useRef(null);
  const closeSearch = useCloseSearch();
  const openSearch = useOpenSearch();
  const isSearchOpen = useIsSearchOpen();
  const isAdvancedSearch = useIsAdvancedSearch();
  const {
    pathname
  } = useAdvancedSearchURL();
  let t1;
  let t2;
  if ($[0] !== closeSearch || $[1] !== pathname) {
    t1 = () => {
      if (prevPathnameRef.current !== null && prevPathnameRef.current !== pathname) {
        closeSearch();
      }
      prevPathnameRef.current = pathname;
    };
    t2 = [pathname, closeSearch];
    $[0] = closeSearch;
    $[1] = pathname;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== openSearch) {
    t3 = () => {
      openSearch();
    };
    $[4] = openSearch;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleSearchBarFocus = t3;
  if (isAdvancedSearch) {
    return null;
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = ["*"];
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  let t6;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Configure hitsPerPage={3} facets={t4} filters={ALGOLIA_HAS_LISTABLE_STOCK_FILTER} numericFilters={DEFAULT_SEARCH_MODAL_NUMERIC_FILTERS} attributesToRetrieve={["_highlightResult", "product_id", "name"]} />;
    t6 = <CatchAlgoliaSearchError />;
    t7 = <ClearModalSearchQueryWhenClosed />;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[10] !== closeSearch || $[11] !== handleSearchBarFocus || $[12] !== toggleMobileSearchBar) {
    t8 = <JBSearchBoxNext autoFocus={true} isActive={true} setInactive={_temp} toggleSearchOpen={closeSearch} variant="InstantSearchMobile" handleSearchBarFocus={handleSearchBarFocus} toggleMobileSearchBar={toggleMobileSearchBar} />;
    $[10] = closeSearch;
    $[11] = handleSearchBarFocus;
    $[12] = toggleMobileSearchBar;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== closeSearch || $[15] !== isSearchOpen) {
    t9 = isSearchOpen && <SearchResultsWrapperNext><QuickLinkDialog toggleSearchOpen={closeSearch} variant="mobile"><div className="bg-white absolute w-full z-[1000] pb-36 max-h-[calc(100dvh-7.5rem)] overflow-y-auto overflow-x-hidden" data-xc="search-dropdown-preview"><div className="flex flex-col w-full max-w-none mx-auto px-2 gap-6"><div className=""><div className="bg-gray-50 p-0 rounded-lg h-full" data-xc="search-dropdown-categories"><Index indexName="categories"><Configure hitsPerPage={5} filters="" numericFilters={["fk_store_id=1"]} facetFilters={["is_searchable:1"]} attributesToRetrieve={["objectID", "category_name", "category_sef_url", "url"]} /><CategoryHitsNext toggleSearchOpen={closeSearch} variant="mobile" /></Index></div></div><div className=""><div className="bg-gray-50 rounded-lg" data-xc="search-dropdown-products"><SearchModalProductListMobileNext toggleSearchOpen={closeSearch} /></div></div><div className="min-w-[20%] flex-[0_1_20%] h-full p-0 instant-search-form__each-results-container-non-padded"><Index indexName={ALGOLIA_INDEX_NAME.STATIC_PAGES}><Configure hitsPerPage={3} filters="" numericFilters={["is_active=1", "show_in_search=1", "fk_store_id=1"]} attributesToRetrieve={["objectID", "page", "url"]} /><StaticPageHitsNext toggleSearchOpen={closeSearch} variant="mobile" /></Index><div className="[border-right:1px_solid_#f1f1f1] pt-5 pr-8 pb-10 p-0 min-h-[auto] mb-2 w-full border-0 order-[-1]"><ResultsByCategoryNextMobile toggleSearchOpen={closeSearch} variant="mobile" /></div></div></div></div></QuickLinkDialog><Index indexName={ALGOLIA_INDEX_NAME.REVIEWS}><Configure facets={["*"]} filters="" numericFilters="" facetFilters="" /></Index><Index indexName={ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS}><Configure facets={["*"]} filters="" numericFilters="" /></Index></SearchResultsWrapperNext>;
    $[14] = closeSearch;
    $[15] = isSearchOpen;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8 || $[18] !== t9) {
    t10 = <div className="bg-white max-[1023px]:relative max-[1023px]:z-10"><div className="bg-white relative max-[1023px]:z-10 lg:!z-[1002]"><InstantSearch searchClient={noEmptySearchClient} indexName={ALGOLIA_INDEX_NAME.PRODUCTS}>{t5}{t6}{t7}{t8}{t9}</InstantSearch></div></div>;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};
export default InstantSearchMobileNext;
function _temp() {}